import styled from "styled-components";
import { SPACING } from "../../constants/design/spacing";
import {
  BORDER_COLORS,
  TEXT_COLORS,
  COLORS,
} from "../../constants/design/colors";
import { FONT_SIZE } from "../../constants/design/fontSize";
import { FONT_WEIGHT } from "../../constants/design/fontWeight";

export const TabsWrapper = styled.div`
  display: flex;
  gap: ${SPACING.two}px;
  margin-bottom: ${SPACING.four}px;
  border-bottom: 1px solid ${BORDER_COLORS.two};
`;

const getTabBorderColor = (isActive: boolean): string =>
  isActive ? COLORS.blue.one : "transparent";

const getTabTextColor = (isActive: boolean): string =>
  isActive ? COLORS.blue.one : TEXT_COLORS.two;

const getTabFontWeight = (isActive: boolean): number =>
  isActive ? FONT_WEIGHT.bold : FONT_WEIGHT.medium;

export const Tab = styled.button<{ isActive: boolean }>`
  padding: ${SPACING.two}px ${SPACING.four}px;
  background: transparent;
  border: none;
  border-bottom: 2px solid ${({ isActive }) => getTabBorderColor(isActive)};
  color: ${({ isActive }) => getTabTextColor(isActive)};
  font-size: ${FONT_SIZE.two};
  font-weight: ${({ isActive }) => getTabFontWeight(isActive)};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: ${COLORS.blue.one};
  }
`;
